import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useSettings } from "../../lib/site";

const FIELDS = [
  ["address", "Indirizzo"],
  ["city", "Città"],
  ["phone", "Telefono (visualizzato)"],
  ["whatsapp", "Numero WhatsApp (con prefisso, es. 393935104463)"],
  ["instagram", "Link Instagram (https://instagram.com/...)"],
];

export const AdminSettings = () => {
  const s = useSettings();
  const qc = useQueryClient();
  const [f, setF] = useState(s);
  const [busy, setBusy] = useState(false);
  const sKey = JSON.stringify(s);

  useEffect(() => { setF(JSON.parse(sKey)); }, [sKey]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.put("/admin/settings", f); toast.success("Informazioni salvate"); qc.invalidateQueries({ queryKey: ["settings"] }); }
    catch (x) { toast.error(errMsg(x)); } finally { setBusy(false); }
  };
  const field = "mt-2 block w-full rounded-xl border border-[var(--ink)]/15 bg-white px-3 py-2.5";

  return (
    <form onSubmit={save} data-testid="admin-settings-form" className="grid gap-5 rounded-[2rem] border border-[var(--gold)]/25 bg-white/60 p-6 md:grid-cols-2">
      {FIELDS.map(([k, l]) => (
        <label key={k} className="text-sm">{l}
          <input data-testid={`admin-settings-${k}`} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={field} />
        </label>
      ))}
      <label className="text-sm md:col-span-2">Orari (uno per riga)
        <textarea data-testid="admin-settings-hours" rows={4} value={f.hours || ""} onChange={(e) => setF({ ...f, hours: e.target.value })} className={field} />
      </label>
      <label className="text-sm md:col-span-2">Note sulla posizione (parcheggio, citofono, piano...)
        <textarea data-testid="admin-settings-location_notes" rows={2} value={f.location_notes || ""} onChange={(e) => setF({ ...f, location_notes: e.target.value })} className={field} />
      </label>
      <button data-testid="admin-settings-save" disabled={busy} className="rounded-full bg-[var(--ink)] py-3 text-sm text-[var(--cream)] hover:bg-[var(--gold-deep)] disabled:opacity-60 md:col-span-2">{busy ? "Salvataggio..." : "Salva informazioni"}</button>
    </form>
  );
};
